import React from 'react';
import { observer } from 'mobx-react-lite';
import { useOnBoardingDrawer } from '../../OnBoardingDrawerProvider';
import SelectRegistrationMethod from './SelectRegistrationMethod';
import EMRImport from './EMRImport';
import { addedUserByTypeEnum } from '../../hooks/types';
import { emrType } from '../../../../../../services/intakeDataService/emrPatientsService';

const RegistrationStep = () => {
  const {
    contextData: { addedUserByType },
  } = useOnBoardingDrawer();

  return addedUserByType === addedUserByTypeEnum.pointClick ? (
    <EMRImport emr={emrType.pointClick} />
  ) :
    addedUserByType === addedUserByTypeEnum.epic ? (
      <EMRImport emr={emrType.epic} />
    ) : 
      addedUserByType === addedUserByTypeEnum.yardi ? (
        <EMRImport emr={emrType.yardi} />
      ) : (
      <SelectRegistrationMethod />
    );
};

export default observer(RegistrationStep);
